import React from "react";

type RoleToggleProps = {
  options: string[];
  active: string;
  onChange: (value: string) => void;
};

const RoleToggle: React.FC<RoleToggleProps> = ({
  options,
  active,
  onChange,
}) => {
  return (
    <div
      className="inline-flex rounded-full bg-white border border-[#D8D8D8] py-0.5 px-1 space-x-2"
      role="group"
    >
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onChange(option)}
          className={`px-4 py-2 text-sm rounded-full transition-colors duration-200 ${
            active === option
              ? "bg-[#303030] text-white"
              : "bg-transparent text-[#212121]/70"
          }`}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default RoleToggle;
